export default __webpack_public_path__ + "static/national-metric-mobile-9e2d8f10038d5b0d72737a2746672d55.svg";